import React, { useState, useCallback } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Box, Typography, Tooltip, IconButton } from "@mui/material";
import EmailFilterModel from "../../core/api/email/EmailFilterModel";
import EmailFilterForm from "../../components/email/EmailFilterForm";
import EmailRecipientsTable from "components/email/EmailRecipientsTable";
import BatchEmailModel from "core/api/email/BatchEmailModel";
import PageRequest from "../../core/api/PageRequest";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { RootContainer } from "./styles/EmailResultViewStyles";
import { styled } from "@mui/material/styles";
import { FilterDrawer } from "../../components/common/FilterDrawer";

const BackButton = styled(IconButton)(({ theme }) => ({
  position: "fixed",
  top: theme.spacing(2),
  right: theme.spacing(2),
  zIndex: theme.zIndex.drawer - 1,
  backgroundColor: theme.palette.grey[200],
  '&:hover': {
    backgroundColor: theme.palette.grey[300],
  },
}));

export const EmailResultView: React.FC = () => {
  const { resultId = '' } = useParams<{ resultId: string }>();
  const [filter, setFilter] = useState<EmailFilterModel>({
    dateFrom: "",
    dateTo: "",
    user: "",
    status: "",
    email: "",
    clientId: "",
    opened: "",
  });
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const navigate = useNavigate();
  
  const handleFilterToggle = useCallback(() => {
    setIsFilterOpen(prev => !prev);
  }, []);

  const handleFilterChange = useCallback((newFilter: EmailFilterModel) => {
    setFilter(prevFilter => ({ ...prevFilter, ...newFilter }));
  }, []);

  const handleGoBack = useCallback(() => {
    navigate(-1);
  }, [navigate]);

  const fetchFn = useCallback(
    (page: PageRequest) => {
      if (!resultId) {
        throw new Error("Result ID is required");
      }
      return BatchEmailModel.emailRecipients(resultId, page, filter as unknown as Record<string, unknown>);
    },
    [filter, resultId]
  );

  if (!resultId) {
    return (
      <RootContainer>
        <Typography variant="h6" sx={{ p: 3 }}>
          Email result ID is required
        </Typography>
      </RootContainer>
    );
  }

  const mainContent = (
    <Box sx={{ position: 'relative' }}>
      <EmailRecipientsTable fetchFunction={fetchFn} />
      <Tooltip title="Grįžti atgal" placement="left">
        <BackButton 
          onClick={handleGoBack}
          aria-label="go back"
        >
          <ArrowBackIcon />
        </BackButton>
      </Tooltip>
    </Box>
  );

  const filterContent = (
    <EmailFilterForm filter={filter} onFilterChange={handleFilterChange} />
  );

  return (
    <RootContainer>
      <FilterDrawer
        open={isFilterOpen}
        onToggle={handleFilterToggle}
        filterContent={filterContent}
      >
        {mainContent}
      </FilterDrawer>
    </RootContainer>
  );
};

export default EmailResultView;
